<template lang="pug">
  FixedWidthTweakUpper
    router-view
</template>

<script>
  import FixedWidthTweakUpper from '../../../FixedWidthTweakUpper';

  export default {
    name: "EditAutoDelivery",
    components: {
      FixedWidthTweakUpper,
    },
  }
</script>

<style scoped lang="stylus">

</style>
